import Styled from 'styled-components'
import {urlChannel} from "../../utils";

export const Button = Styled.button`
    width: ${props => props.width ? props.width : '100%'};
    color: ${props => props.outline ? 'var(--button-primary-color)' : 'var(--button-primary-text)'};
    background-color: ${props => props.outline ? 'transparent' : props.bgDisabled ? props.bgDisabled :  !props.bgDisabled && localStorage.getItem('channel') === 'genial' ? '#050922' : 'var(--button-primary-color)'};
    border: 0;
    font-weight: 700;
    font-size: 12px;
    padding: 16px 10px;
    border-radius: 4px;
    border: 1px solid ${props => props.bgDisabled ? props.bgDisabled : localStorage.getItem('channel') === 'genial' ? '#050922' : 'var(--button-primary-color)'};
    
    svg {
        margin-top: -3px;
    }

    &:disabled {
        background-color: #C4C4C4;
        border-color: #C4C4C4;
        color: #FFFFFF;
        opacity: 0.7;
        cursor: not-allowed;
    }

:active{
    opacity: 0.6;
}
`